var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 13.0908V19.2872H24.6106C24.2325 21.2799 23.0978 22.9673 21.3961 24.1018L26.5888 28.1309C29.6142 25.3383 31.3597 21.2364 31.3597 16.3637C31.3597 15.2292 31.2579 14.1382 31.0687 13.091L15.9998 13.0908Z",
    fill: "#F4F1DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03286 19.0454L5.86171 19.9419L1.71619 23.171C4.34891 28.3927 9.74487 32.0001 15.9994 32.0001C20.3193 32.0001 23.941 30.5746 26.5884 28.131L21.3957 24.1019C19.9702 25.0619 18.152 25.6438 15.9994 25.6438C11.8394 25.6438 8.30495 22.8365 7.0394 19.0546L7.03286 19.0454Z",
    fill: "#F4F1DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.71624 8.8291C0.625389 10.9817 0 13.4109 0 15.9999C0 18.589 0.625389 21.0181 1.71624 23.1707C1.71624 23.1852 7.03997 19.0398 7.03997 19.0398C6.71997 18.0798 6.53082 17.0617 6.53082 15.9997C6.53082 14.9378 6.71997 13.9197 7.03997 12.9597L1.71624 8.8291Z",
    fill: "#F4F1DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 6.3709C18.3561 6.3709 20.4506 7.18543 22.1233 8.75636L26.7051 4.1746C23.9269 1.58555 20.3198 0 15.9997 0C9.7452 0 4.34891 3.59272 1.71619 8.8291L7.03975 12.96C8.30513 9.17816 11.8397 6.3709 15.9997 6.3709Z",
    fill: "#F4F1DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ffc894931474ec0ecb04a581cea83f89.svg";
export { ForwardRef as ReactComponent };